export default __webpack_public_path__ + "static/media/pre_solicitud.18ad5677.png";